<style>
.padding_10 {
  padding: 0px !important;
}
</style>
<template>
  <div>
    <div v-if="submit_loader" style="
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        padding-top: 25%;
        background-color: rgba(255, 255, 255, 0.31);
      ">
      <div class="text-xs-center" large></div>
    </div>
    <v-container fluid grid-list-md class="padding_10" v-else>
      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12 sm8 md8 class="text-xs-left">
        </v-flex>
      </v-layout>
      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12>
          <v-card>
            <v-form id="create_coupon" data-vv-scope="CreateCampaign" @submit.prevent="validateBeforeSubmit('CreateCampaign')">
              <input type="hidden" name="campaign_id" v-model="campaign_object.id" />
              <v-card-text>
                <v-layout row wrap>
                  <!-- <v-flex xs12 md12 lg12> -->
                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>Name <span style="color: red;">*</span></label>
                    </v-flex>
                    <v-text-field name="name" v-model="campaign_object.name" label="Name"
                      v-validate="'required'" :error-messages="errors.collect('CreateCampaign.name')" clearable
                      solo flat @input="formatName" data-vv-as="Name"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>Title <span style="color: red;">*</span></label>
                    </v-flex>
                    <v-text-field name="title" v-model="campaign_object.title"
                      label="Title" v-validate="'required'"
                      :error-messages="errors.collect('CreateCampaign.title')" clearable solo flat
                      data-vv-as="Title"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>Description <span style="color: red;">*</span></label>
                    </v-flex>
                    <v-text-field name="description" v-model="campaign_object.description"
                      label="Description" v-validate="'required'"
                      :error-messages="errors.collect('CreateCampaign.description')" clearable solo flat
                      data-vv-as="Description"></v-text-field>
                  </v-flex>
                  
                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>Campaign Image URL <span style="color: red;">*</span></label>
                    </v-flex>
                    <v-text-field name="campaign_image_url" v-model="campaign_object.campaign_image_url"
                      label="Campaign Image URL" v-validate="'required|url'"
                      :error-messages="errors.collect('CreateCampaign.campaign_image_url')" clearable solo flat
                      data-vv-as="Campaign Image URL"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>Campaign Type <span style="color: red;">*</span></label>
                    </v-flex>
                    <v-select
                      :items="['html', 'media']"
                      name="campaign_type"
                      v-model="campaign_object.campaign_type"
                      label="Campaign Type"
                      v-validate="'required'"
                      :error-messages="errors.collect('CreateCampaign.campaign_type')"
                      clearable
                      solo
                      flat
                      data-vv-as="Campaign Type"
                    ></v-select>
                  </v-flex>

                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>Campaign Type URL <span style="color: red;">*</span></label>
                    </v-flex>
                    <v-text-field name="campaign_type_url" v-model="campaign_object.campaign_type_url"
                      label="Campaign Type URL" v-validate="'required|url'"
                      :error-messages="errors.collect('CreateCampaign.campaign_type_url')" clearable solo flat
                      data-vv-as="Campaign Type URL"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>Start Date <span style="color: red;">*</span></label>
                    </v-flex>
                    <v-flex xs12 md12 lg12 style="display: flex; flex-wrap: wrap; padding:0px !important">
                      <v-menu ref="menuStart" v-model="campaign_object.menu_start_date" :close-on-content-click="false"
                        transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="campaign_object.start_date"
                            name="start_date"
                            v-validate="'required'"
                            data-vv-scope="CreateCampaign"
                            :error-messages="errors.collect('CreateCampaign.start_date')"
                            label="Select Date"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            solo
                            flat
                            data-vv-as="Start Date"
                          ></v-text-field>
                        </template>

                        <v-date-picker v-model="campaign_object.start_date" no-title scrollable :min="current_date">
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="campaign_object.start_date = null">Clear</v-btn>
                          <v-btn text color="primary" @click="campaign_object.menu_start_date = false">Cancel</v-btn>
                          <v-btn text color="primary" @click="$refs.menuStart.save(campaign_object.start_date)">OK</v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-flex>

                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>End Date <span style="color: red;">*</span></label>
                    </v-flex>
                    <v-flex xs12 md12 lg12 style="display: flex; flex-wrap: wrap; padding:0px !important">
                      <v-menu ref="menuEnd" v-model="campaign_object.menu_end_date" :close-on-content-click="false"
                        transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="campaign_object.end_date"
                            name="end_date"
                            v-validate="'required'"
                            data-vv-scope="CreateCampaign"
                            :error-messages="errors.collect('CreateCampaign.end_date')"
                            label="Select Date"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            solo
                            flat
                            data-vv-as="End Date"
                          ></v-text-field>
                        </template>

                        <v-date-picker v-model="campaign_object.end_date" no-title scrollable :min="campaign_object.start_date || current_date">
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="campaign_object.end_date = null">Clear</v-btn>
                          <v-btn text color="primary" @click="campaign_object.menu_end_date = false">Cancel</v-btn>
                          <v-btn text color="primary" @click="$refs.menuEnd.save(campaign_object.end_date)">OK</v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-flex>

                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>Display Interval Hours <span style="color: red;">*</span></label>
                    </v-flex>
                    <v-text-field name="display_interval_hours" v-model="campaign_object.display_interval_hours"
                      label="Display Interval Hours" v-validate="'required|integer|min_value:0'"
                      :error-messages="errors.collect('CreateCampaign.display_interval_hours')" clearable solo flat
                      maxlength="6" @keypress="allowInteger($event)"
                      data-vv-as="Display Interval Hours"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>iOS Deeplink URL <span style="color: red;">*</span></label>
                    </v-flex>
                    <v-text-field name="ios_deeplink_url" v-model="campaign_object.ios_deeplink_url"
                      label="iOS Deeplink URL" v-validate="'required|url'"
                      :error-messages="errors.collect('CreateCampaign.ios_deeplink_url')" clearable solo flat
                      data-vv-as="iOS Deeplink URL"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>Android Deeplink URL <span style="color: red;">*</span></label>
                    </v-flex>
                    <v-text-field name="android_deeplink_url" v-model="campaign_object.android_deeplink_url"
                      label="Android Deeplink URL" v-validate="'required|url'"
                      :error-messages="errors.collect('CreateCampaign.android_deeplink_url')" clearable solo flat
                      data-vv-as="Android Deeplink URL"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>Terms & Conditions URL </label>
                    </v-flex>
                    <v-text-field name="terms_cond_url" v-model="campaign_object.terms_cond_url"
                      label="Terms & Conditions URL" v-validate="'required|url'"
                      :error-messages="errors.collect('CreateCampaign.terms_cond_url')" clearable solo flat
                      data-vv-as="Terms & Conditions URL"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>Steps</label>
                    </v-flex>
                    <v-textarea name="steps" v-model="campaign_object.steps"
                      label="Steps (JSON String)"
                      :error-messages="errors.collect('CreateCampaign.steps')" clearable solo flat
                      rows="3" auto-grow data-vv-as="Steps"></v-textarea>
                  </v-flex>
                  
                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" small :disabled="submit_loader" type="submit">
                  {{ isEditMode ? 'Update' : 'Create' }}
                </v-btn>
                <v-btn flat small to="/yatri-campaign" @click="cancelForm">Cancel</v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-flex>
      </v-layout>
      <v-snackbar :color="snackBar.color" :top="snackBar.top" :bottom="snackBar.bottom" :left="snackBar.left"
        :right="snackBar.right" v-model="snackBar.show">
        {{ snackBar.message }}
        <v-btn dark flat @click.native="snackBar.show = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import moment from "moment";
import axios from 'axios';

  export default {
    name: "CreateCampaign",

    props: {
      prefillData: {
        type: Object,
        default: null,
      },
    },

    data() {
      const today = new Date().toISOString().substr(0, 10);

      return {
        valid: false,
        submit_loader: false,

        current_date: today,

        campaign_object: {
          id: null,
          name: null,
          title: null,
          description: null,
          campaign_image_url: null,
          campaign_type: 'media',
          campaign_type_url: null,
          start_date: today,
          menu_start_date: false,
          end_date: today,
          menu_end_date: false,
          display_interval_hours: null,
          ios_deeplink_url: null,
          android_deeplink_url: null,
          terms_cond_url: null,
          steps: null,
        },

        snackBar: {
          show: false,
          message: "",
          color: "",
          top: true,
          right: true,
        },
      };
    },

    computed: {
      isEditMode() {
        return !!this.campaign_object.id;
      },
    },

    watch: {
      prefillData: {
        handler(newVal) {
          if (newVal) {
            this.campaign_object.id = newVal.campaign_id || newVal.edit_campaign_id || newVal.campaignId || newVal.campaign_uuid || newVal.id || newVal._id || newVal.uuid || null;
            this.campaign_object.name = newVal.name || null;
            this.campaign_object.title = newVal.title || null;
            this.campaign_object.description = newVal.description || null;
            this.campaign_object.campaign_image_url = newVal.campaign_image_url || null;
            this.campaign_object.campaign_type = newVal.campaign_type || null;
            this.campaign_object.campaign_type_url = newVal.campaign_type_url || null;
            this.campaign_object.start_date = newVal.start_date || this.current_date;
            this.campaign_object.menu_start_date = false;
            this.campaign_object.end_date = newVal.end_date || this.current_date;
            this.campaign_object.menu_end_date = false;
            this.campaign_object.display_interval_hours =
              newVal.display_interval_hours ??
              newVal.displayIntervalHours ??
              newVal.display_interval_hour ??
              null;
            this.campaign_object.ios_deeplink_url = newVal.ios_deeplink_url || null;
            this.campaign_object.android_deeplink_url = newVal.android_deeplink_url || null;
            this.campaign_object.terms_cond_url = newVal.terms_cond_url || null;
            this.campaign_object.steps = this.formatStepsForInput(newVal.steps);

            // Scroll to form
            window.scrollTo({ top: 0, behavior: 'smooth' });
          } else {
            this.resetCampaignObject();
          }
        },
        immediate: true,
      },
    },

    methods: {
      reloadPage() {
        window.location.reload();
      },
      cancelForm() {
        this.resetCampaignObject();
        this.$emit("clear-prefill");
      },
      resetCampaignObject() {
        this.campaign_object = {
          id: null,
          name: null,
          title: null,
          description: null,
          campaign_image_url: null,
          campaign_type: 'media',
          campaign_type_url: null,
          start_date: this.current_date,
          menu_start_date: false,
          end_date: this.current_date,
          menu_end_date: false,
          display_interval_hours: null,
          ios_deeplink_url: null,
          android_deeplink_url: null,
          terms_cond_url: null,
          steps: null,
        };
      },
      formatStepsForInput(steps) {
        if (steps === null || steps === undefined || steps === "") return null;

        if (typeof steps === "string") {
          try {
            return JSON.stringify(JSON.parse(steps), null, 2);
          } catch (e) {
            return steps;
          }
        }

        try {
          return JSON.stringify(steps, null, 2);
        } catch (e) {
          return String(steps);
        }
      },
      getStepsPayload() {
        const rawSteps = this.campaign_object.steps;

        if (rawSteps === null || rawSteps === undefined || String(rawSteps).trim() === "") {
          return null;
        }

        try {
          const parsed = typeof rawSteps === "string" ? JSON.parse(rawSteps) : rawSteps;
          return JSON.stringify(parsed);
        } catch (e) {
          this.snackBar.message = "Steps must be valid JSON.";
          this.snackBar.color = "error";
          this.snackBar.show = true;
          return null;
        }
      },
      formatName() {
        const current = this.campaign_object.name || "";
        this.campaign_object.name = current
          .replace(/\s{2,}/g, " ")
          .trimStart();
      },
      validateBeforeSubmit(scope) {
        this.$validator.validateAll(scope).then((result) => {
          if (result) {
            this[scope]();
          } else {
            this.snackBar.message = "Please fill all required fields correctly.";
            this.snackBar.show = true;
          }
        });
      },
      allowFloat(e, field) {
        const char = String.fromCharCode(e.keyCode || e.which);
        const value = this.campaign_object[field] || "";

        if (/^[0-9]$/.test(char)) return;

        if (char === '.' && !value.includes('.')) return;

        e.preventDefault();
      },
      allowInteger(e) {
        const char = String.fromCharCode(e.keyCode || e.which);

        if (/^[0-9]$/.test(char)) return;

        e.preventDefault();
      },

      preventDoubleDot(field) {
        let v = this.campaign_object[field] || "";
        const firstDot = v.indexOf(".");
        const lastDot = v.lastIndexOf(".");

        if (firstDot !== lastDot) {
          this.campaign_object[field] = v.replace(/\.(?=.*\.)/, "");
        }
      },
      CreateCampaign() {
        this.submit_loader = true;

        const campaignId = this.campaign_object.id ? String(this.campaign_object.id).trim() : "";
        const isEdit = !!campaignId;

        if (this.isEditMode && !campaignId) {
          this.snackBar.message = "Campaign ID is missing for update.";
          this.snackBar.color = "error";
          this.snackBar.show = true;
          this.submit_loader = false;
          return;
        }

        const stepsPayload = this.getStepsPayload();
        if (!stepsPayload) {
          this.submit_loader = false;
          return;
        }

        const payload = {
          ...(isEdit ? { campaign_id: campaignId } : {}),
          name: this.campaign_object.name,
          title: this.campaign_object.title,
          description: this.campaign_object.description,
          campaign_image_url: this.campaign_object.campaign_image_url,
          campaign_type: this.campaign_object.campaign_type,
          campaign_type_url: this.campaign_object.campaign_type_url,
          start_date: this.campaign_object.start_date,
          end_date: this.campaign_object.end_date,
          display_interval_hours: this.campaign_object.display_interval_hours,
          ios_deeplink_url: this.campaign_object.ios_deeplink_url,
          android_deeplink_url: this.campaign_object.android_deeplink_url,
          terms_cond_url: this.campaign_object.terms_cond_url,
          steps: stepsPayload,
        };

        if (stepsPayload === null) {
          delete payload.steps;
        }

        axios.post(
          `${process.env.VUE_APP_API_URL}/api/v4/${isEdit ? 'update-campaign' : 'insert-campaign'}`,
          payload,
          { headers: this.$headers }
        )
          .then((response) => {
            if (response.data.status == 1) {

              this.snackBar.message = response.data.message;
              this.snackBar.show = true;

              this.$emit("created");
              this.$emit("clear-prefill");
              this.resetCampaignObject();

            } else {
              this.snackBar.message = response.data.message;
              this.snackBar.show = true;
            }

          })
          .finally(() => {
            this.submit_loader = false;
          });
      }
    },
    mounted() {
      this.current_date = moment().format("YYYY-MM-DD");
    }
  };

</script>
